import { useSelector, useDispatch } from "react-redux";
import { setFilter, removeFilter, setLoading } from "../../configureStore";
let timeOut = null;
const CheckboxItems = (props) => {
	const dispatch = useDispatch();
	const searchData = useSelector((state) => state.searchData);
	const onChange = async(name, id, el) => {
		const type = props.type;
		clearTimeout(timeOut);
		if (el.target.checked === true) {
			// Get activities from selected activity group
			await dispatch(setFilter({ name, id, type }));
		} else {
			await dispatch(removeFilter({ id, type }));
		}
		if(window.initialState.page === 'search'){
			timeOut =  setTimeout (async () => {
				// fetch results
				dispatch(setLoading(true));
			}, 800);
		}
	};
	// check if  url has params or filters were removed from pills
	const setCheckStatus = (name, id, e) => {
		return searchData.filters[props.type][id] ? true : false;
	};

	return props.options.map((item, index) => {
		let id = null;
		let name = null;
		if (item.activityGroupId) {
			id = item.activityGroupId;
			name = item.activityGroupName;
		} else if (item.amenityId) {
			name = item.name;
			id = item.amenityId;
		} else if (item.discountCategoryId) {
			name = item.name;
			id = item.discountCategoryId;
		}

		return (
			<div
				className={`form__grid-item ${
					!props.showMore && index > props.showmoreIndex ? "hidden" : ""
				}`}
				id={id}
				key={id + name}>
				<div className="form__group ">
					<div className="form__check">
						<input
							type="checkbox"
							name={`${id}-${props.type}`}
							id={`check-${id}-${props.type}`}
							checked={setCheckStatus(name, id)}
							className="form__check-input"
							onChange={(e) => {
								onChange(name, id, e);
							}}
						/>
						<label
							className="form__check-label"
							htmlFor={`check-${id}-${props.type}`}>
							{name}
						</label>
					</div>
				</div>
			</div>
		);
	});
};

export default CheckboxItems;
